<template>
  <!-- Current Location -->
  <div
    class="storelocater-col-md-3 storelocater-col-sm-3 text-right storelocator__location rfp-storelocator-tcell"
    :class="{ storelocatorpdp: productPage }"
  >
    <button class="location-btn" @click="handleCurrentLocation()">
      <img
        v-if="locationIcon && locationIcon.length > 1"
        :src="locationIcon"
        :alt="locationIconAlt"
        class="Rfp-storelocater-image"
        :class="{ 'rfp-storelocator-rtl': enableRtl }"
      />
      <span class="current-location-button-text Rfp-storelocater-current-location">{{
        btnName
      }}</span>
    </button>
  </div>
  <!--  End current location button -->
</template>

<script>
import eventBus from '@refapp/eventbus-js';

/* global google */

/**
 * @module Component/CurrentLocation
 * @desc the CurrentLocation tag implement
 */
export default {
  /**
   * @member {type} name tag name of the component
   * @readonly
   */
  name: 'rfp-storelocator-current-location',
  props: {
    /**
     * @member {string} Button title
     * @desc title of the Button
     */
    btnName: {
      type: String,
      required: true,
    },
    /**
     * @member {string} Button title
     * @desc title of the Button
     */
    locationIcon: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * @member {string} Button title
     * @desc title of the Button
     */
    locationIconAlt: {
      type: String,
      required: false,
      default: '',
    },
    enableRtl: {
      type: Boolean,
      default: false,
    },
    defaultRadius: {
      type: String,
      required: true,
    },
    defaultDistanceMetric: {
      type: String,
      required: true,
    },
    currentLocationTags: {
      type: String,
      required: false,
    },
    iriEnabled: {
      type: Boolean,
      default: true,
    },
  },
  /**
   * @function data
   * @desc init the data when the component mount
   */
  data() {
    return {
      productPage: true,
      isCurrentLocation: false,
    };
  },
  /**
   * @function created
   * @desc on mounting,initiate the function
   */
  created() {
    // init the getlocation
    eventBus.on('currentPlace', () => {
      this.getLocation();
    });
    eventBus.on('enablePdp', () => {
      this.productPage = false;
    });
  },
  methods: {
    sendTaggingData() {
      if (this.isCurrentLocation && this.currentLocationTags) {
        let taggingData = {};
        let tags = {};
        try {
          tags = JSON.parse(this.currentLocationTags);
        } catch (e) {
          console.error(
            'error/rfp-storelocator-currentLocation#mounted: Invalid JSON for current location tags. ',
            e,
          );
          this.isCurrentLocation = false;
          return;
        }
        eventBus.on('postalCode', (zip) => {
          const DEFAULT_ZIP_TEXT = '[zipcode or city]';
          taggingData = Object.entries(tags).reduce((accumulator, [key, value]) => {
            const isZipCodeField = value.includes(DEFAULT_ZIP_TEXT);
            accumulator[key] = isZipCodeField
              ? value.replace(DEFAULT_ZIP_TEXT, zip)
              : value.toLowerCase();
            return accumulator;
          }, {});
          if (window.dataLayer !== undefined && taggingData !== {}) {
            window.dataLayer.push(taggingData);
            this.isCurrentLocation = false;
          }
          eventBus.off('postalCode');
        });
      }
    },
    /**
     * @function showPosition
     * @desc showPosition get the lat and lon from current location.
     */
    showPosition(position) {
      eventBus.emit('storeMsg');
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;
      const latlon = new google.maps.LatLng(lat, lng);
      const gcode = new google.maps.Geocoder();
      const latLng = {
        lat: lat,
        lon: lng,
        distances: this.defaultRadius,
        distanceTypes: this.defaultDistanceMetric,
      };
      if (!this.iriEnabled) {
        this.emitPositionRelatedEvents(latLng);
      }

      gcode.geocode({ latLng: latlon }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const resultWithPostalCode = results.find((result) =>
            result.address_components.some((el) => el.types.includes('postal_code')),
          );
          if (resultWithPostalCode) {
            const postalCodeComponent = resultWithPostalCode.address_components.find((el) =>
              el.types.includes('postal_code'),
            );
            if (postalCodeComponent) {
              const postalCode = postalCodeComponent.long_name;
              eventBus.emit('postalCode', postalCode);
              if (this.iriEnabled) {
                latLng.zip = postalCode;
                this.emitPositionRelatedEvents(latLng);
              }
            }
          }
        }
      });
    },
    /**
     * @function emitPositionRelatedEvents
     * @desc emitPositionRelatedEvents emit events related to showPosition function call
     */
    emitPositionRelatedEvents(data) {
      eventBus.emit('mapData', data);
      eventBus.emit('invalidMsg');
    },
    /**
     * @function getLocation
     * @desc getLocation display the geographic location of a user or device on a Google map
     */
    getLocation() {
      eventBus.emit('defaultDistanceEmpty');
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((location) => {
          if (window.google) {
            eventBus.emit('Rfp-Geo-Location-Status', true);
            this.showPosition(location);
          }
        });
      } else {
        eventBus.emit('Rfp-Geo-Location-Status', false);
        eventBus.emit('locationMsg');
      }
    },
    /**
     * @function handleCurrentLocation
     * @desc handleCurrentLocation sets the boolean isCurrentLocation before calling getLocation function
     */
    handleCurrentLocation() {
      this.isCurrentLocation = true;
      this.getLocation();
      this.sendTaggingData();
    },
  },
};
</script>
